module.exports = __webpack_public_path__ + "static/media/elegir_metodo_run_serial_preguntas_clave_unica.bd9e0336.svg";